import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Fragment from 'vue-fragment'
import './quasar'
import './antd'
import '@/lib/enums'
import '@/lib/api'
import '@/components'
import '@/lib/mock'
import print from 'print-js'
import 'print-js/dist/print.css'
import '@/directives/resize'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import LocaleProvider from 'ant-design-vue'
import vueSwiper from 'vue-awesome-swiper' // 引入轮播图组件
Vue.use(vueSwiper)
Vue.use(LocaleProvider)

Vue.use(Fragment.Plugin)

Vue.config.productionTip = false
if (!Array.prototype.at) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function (index) {
    return this ? this[index] : undefined
  }
}

Object.defineProperty(Vue.prototype, '$$webconfig', {
  get () {
    // eslint-disable-next-line no-undef
    return webconfig
  }
})

// 参考：https://juejin.cn/post/6888519415717953549
Object.defineProperty(Vue.prototype, '$$print', {
  get () {
    return print
  }
})

Object.defineProperty(Vue.prototype, '$$bisconfig', {
  get () {
    return store.getters['bis/authorize/configModel']
  }
})

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
